import { getCurrentInstance } from "vue";
export const useViewer = () => {
    const instance = getCurrentInstance();
    const showViewer = (images) => {
        if (instance && images.length > 0) {
            instance.proxy.$viewerApi({
                images,
            });
        }
    };
    return {
        showViewer,
    };
};
